<template>
  <div>
    <h3>近三年经营状况</h3>
    <el-table :data="dataList" size="small" stripe style="width: 100%;">
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column label="序号" header-align="center" align="center" width="50" prop="index">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="year" label="年份" align="center" header-align="center">
        <template slot-scope="scope">
          <span style="color: red;">*</span>
          <span>{{scope.row.year}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalOutput" label="总产量" align="center" header-align="center">
        <template slot-scope="scope">
          <span>{{scope.row.totalOutput}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalSales" label="销售总收入（万元）(含税）" align="center" header-align="center">
        <template slot-scope="scope">
          <span>{{scope.row.totalSales}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalProductivity" label="全员劳动生产率（万元/人）" header-align="center" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.totalProductivity}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="afterTaxProfit" label="税后利润（万元）" header-align="center" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.afterTaxProfit}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="imitatePartOutput" label="拟引入零部件产量" header-align="center" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.imitatePartOutput}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="imitatePartTotalSales" label="拟引入零部件销售总收入（万元）(含税）" header-align="center" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.imitatePartTotalSales}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10,15,20]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  import {getSupplieInfo4} from '@/controller/supplier'
  export default {
    data () {
      return {
        show:false,
        totalPage: 0,
        pageIndex:1,
        pageSize:15,
        dataForm: {
          key: ''
        },
        dataListLoading: false,
        editRowslist: [],
        dataList: [
          { year: new Date().getFullYear()-1, value: '1' },
          { year: new Date().getFullYear()-2, value: '2' },
          { year: new Date().getFullYear()-3, value: '3' },
        ],
        year: '',
        totalOutput: '',
        totalSales: '',
        totalProductivity: '',
        afterTaxProfit: '',
        imitatePartOutput: '',
        imitatePartTotalSales: '',
        venderInviteFid: '',
        dataListSelections: []
      }
    },
    props: {
      superId: Number
    },
    methods: {
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      getDataList() {
        getSupplieInfo4({
          'pageNo': this.pageIndex,
          'pageSize': this.pageSize,
          'id' : this.superId
        }).then(data => {
          if (data && data.code === '00') {
            if (data.body.records.length > 0){
              this.dataList = data.body.records
              this.totalPage = data.body.total
            }
          } else {
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
    }
  }
</script>
